export default function renderReact() {
  if (this.param.renderReact != null) {
    this.param.renderReact();
    this.param.renderReact = null;
  }
}
